module.exports = __webpack_public_path__ + "media/e-commerce.037dc6f1.mp4";